<template>
  <div>
    <!-- <PageHead title="组织机构管理列表"></PageHead> -->
    <PageHead title="人员管理"></PageHead>
    <div class="userList">
      <a-layout>
        <a-layout-sider style="background: #fff">
          <div class="user-menu-cont">
            <a-tree
              v-if="treeData.length > 0"
              :tree-data="treeData"
              @select="onSelect"
              :replaceFields="replaceFields"
              :default-expanded-keys="expandedKeys"
            >
            </a-tree>
          </div>
        </a-layout-sider>
        <a-layout>
          <a-layout-content>
            <div class="userList-layout-cont">
              <div class="search-flex">
                <div class="search-flex-item mr20">
                  <span>姓名：</span>
                  <a-input
                    class="w200"
                    placeholder="请输入姓名"
                    v-model="queryForm.fullName"
                  />
                </div>
                <div class="search-flex-item mr20">
                  <span>职务：</span>
                  <a-select
                    class="w200"
                    placeholder="不限"
                    v-model="queryForm.dutiesVal"
                  >
                    <a-select-option
                      v-for="item in dutiesValList"
                      :value="item.valuename"
                      :key="item.id"
                    >
                      {{ item.keyname }}</a-select-option
                    >
                  </a-select>
                </div>

                <div class="search-flex-item">
                  <a-button type="primary" @click="subMit" :loading="loading">
                    查询</a-button
                  >
                  <a-button :style="{ marginLeft: '8px' }" @click="cancel">
                    取消
                  </a-button>
                </div>
              </div>
              <div class="mt20 mb20">
                <a-button type="primary" @click="add()" icon="plus">
                  新建</a-button
                >
                <a-button
                  :loading="sysLoading"
                  class="ml20"
                  type="primary"
                  @click="getSysPersonnelStateFn"
                  icon="sync"
                >
                  同步人事花名册</a-button
                >
              </div>
              <a-table
                :pagination="false"
                :columns="columns"
                :data-source="data"
                rowKey="id"
                :loading="loading"
              >
                <span slot="index" slot-scope="text, record, index">
                  {{ index + 1 + (page - 1) * 10 }}
                </span>
                <span slot="dutiesVal" slot-scope="text">{{
                  getByTypeName(text, dutiesValList)
                }}</span>
                <div slot="status" class="statusDiv" slot-scope="text, record">
                  <a-switch
                    :checked="text == 1"
                    @change="enableNumChange(record)"
                  />
                </div>
                <div slot="action" slot-scope="text, record">
                  <!-- <a-button
                    type="link"
                    class="btn-link"
                    @click="showDeleteConfirm(record.id)"
                  >
                    重置密码
                  </a-button>
                  <a-divider type="vertical" /> -->
                  <!-- <a-button
                    type="link"
                    class="btn-link"
                    @click="setrole(record.id)"
                  >
                    权限设置
                  </a-button> -->
                  <a-button
                    type="link"
                    class="btn-link"
                    @click="add(record.id)"
                  >
                    编辑
                  </a-button>
                </div>
              </a-table>
              <div class="pagination">
                <a-pagination
                  v-model="page"
                  :total="total"
                  :pageSize="size"
                  @change="pageChange"
                />
              </div>
            </div>
          </a-layout-content>
        </a-layout>
      </a-layout>
      <a-modal
        v-model="visible"
        title="权限设置"
        @ok="handleOk"
        :confirm-loading="confirmLoading"
      >
        <a-descriptions layout="vertical" :column="2">
          <a-descriptions-item label="资料权限">
            <a-radio-group v-model="updateData.secretLevel">
              <a-radio :value="100"> 重要 </a-radio>
              <a-radio :value="10"> 普通 </a-radio>
            </a-radio-group>
          </a-descriptions-item>
          <a-descriptions-item label="启用/禁用">
            <a-radio-group v-model="updateData.enableNum">
              <a-radio :value="1"> 启用 </a-radio>
              <a-radio :value="2"> 禁用 </a-radio>
            </a-radio-group>
          </a-descriptions-item>
        </a-descriptions>
        <blank height="20"> </blank>

        <div class="userList-formCont">
          <div class="role-formlabel">菜单设置:</div>
          <div class="role-formvalue">
            <a-checkbox-group v-model="updateData.roleIds">
              <a-checkbox
                :value="i.roleId"
                name="type"
                v-for="(i, index) in roleList"
                :key="index"
              >
                {{ i.roleZhName }}
              </a-checkbox>
            </a-checkbox-group>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'index' }
  },
  {
    title: '姓名',
    dataIndex: 'fullName',
    key: 'fullName',
    align: 'left',
    ellipsis: true
  },
  {
    title: '所属部门',
    dataIndex: 'organizationNamePath',
    key: 'organizationNamePath',
    align: 'left',
    ellipsis: true
  },
  {
    title: '职位',
    dataIndex: 'dutiesVal',
    key: 'dutiesVal',
    scopedSlots: { customRender: 'dutiesVal' },
    align: 'left',
    ellipsis: true,
    width: 100
  },
  {
    title: '电话',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    ellipsis: true,
    align: 'left',
    width: 130
  },

  {
    title: '启用',
    dataIndex: 'enableNum',
    key: 'enableNum',
    scopedSlots: { customRender: 'status' },
    align: 'left',
    width: 100
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 100
  }
]

import {
  getUser,
  getTreeList,
  updateUser,
  updateStatus,
  resetPassword,
  getRoleList,
  getUserDetails,
  sysPersonnel,
  getSysPersonnelState
} from './api/api'
import { deepClone } from '@/assets/js/auth'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      confirmLoading: false,
      sysLoading: false,
      loading: false,
      treeData: [],
      selectedKeys: 10010, //当前点击的机构ID
      expandedKeys: [10010], //当前默认选中的机构 ，为了保证默认展开
      replaceFields: {
        children: 'treeList',
        title: 'organizationName',
        key: 'id'
      },
      visible: false,
      data: [], //用户列表信息
      roleList: [], //权限列表
      page: 1,
      size: 10,
      total: 0, //总条数
      columns,
      queryForm: {},
      updateData: {} //当前修改的用户信息
    }
  },
  computed: {
    ...mapState({
      dutiesValList: (state) => state.bytype.dutiesValList // 职务字典表
    })
  },
  created() {
    // this.getUserList()
    getTreeList().then((res) => {
      this.treeData = res.data.data
      this.selectedKeys = this.treeData[0].id
      this.getUserList()
    })
    getRoleList({ page: 1, size: 100, enableNum: 1 }).then((res) => {
      this.roleList = res.data.data
    })
    //职务
    this.getdutiesVal()
  },
  methods: {
    // 查看同步人事花名册按钮可点击状态
    getSysPersonnelStateFn() {
      getSysPersonnelState().then((res) => {
        if (res.data.code == 0) {
          if (res.data.data == true) {
            this.synchronization()
          } else {
            this.$message.warning('正在同步中，请稍后')
          }
        }
      })
    },
    ...mapActions(['getdutiesVal']),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    // 点击左侧组织机构
    onSelect(selectedKeys) {
      if (selectedKeys.length > 0) {
        this.selectedKeys = selectedKeys[0]
      }
      this.page = 1
      this.getUserList()
    },
    getUserList() {
      this.loading = true
      let data = this.queryForm
      data.page = this.page
      data.size = this.size
      data.organizationId = this.selectedKeys
      getUser(data).then((res) => {
        this.loading = false
        this.data = res.data.data
        this.total = res.data.count
      })
    },
    enableNumChange(checked) {
      let data = deepClone(checked)
      if (checked.enableNum == 1) {
        data.enableNum = 2
      } else {
        data.enableNum = 1
      }

      updateStatus(data).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('操作成功')
          this.getUserList()
        }
      })
    },
    handleOk() {
      this.confirmLoading = true
      updateUser(this.updateData).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('权限设置成功')
          this.getUserList()
          this.visible = false
          this.confirmLoading = false
        } else {
          this.confirmLoading = false
        }
      })
    },
    add(id) {
      if (id) {
        this.$router.push('/adduser?id=' + id)
      } else {
        this.$router.push('/adduser')
      }
    },
    setrole(id) {
      // this.updateData = deepClone(user)
      getUserDetails({ id }).then((res) => {
        if (res.data.code == 0) {
          this.updateData = res.data.data
          this.visible = true
        }
      })
    },
    showDeleteConfirm(id) {
      let that = this
      this.$confirm({
        title: '确定重置密码吗?',
        okType: 'danger',
        onOk() {
          resetPassword({ id }).then((res) => {
            if (res.data.code == 0) {
              that.$message.success('重置密码成功')
            }
          })
        }
      })
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.getUserList()
    },
    subMit() {
      this.page = 1
      this.getUserList()
    },
    cancel() {
      //取消
      this.queryForm = {}
    },
    //同步人事花名册
    synchronization() {
      this.$confirm({
        title: '确定同步人事花名册吗?',
        okType: 'danger',
        onOk: () => {
          this.sysLoading = true
          sysPersonnel().then((res) => {
            if (res.data.code == 0) {
              this.$success({
                title: res.data.msg,
                okText: '确定',
                onOk: () => {
                  this.page = 1
                  this.getUserList()
                }
              })
              this.sysLoading = false
            } else {
              this.sysLoading = false
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.userList {
  margin: 24px 16px;
  .userList-layout-cont {
    margin-left: 10px;
    padding: 20px;
    background: #fff;
    .search-flex {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-wrap: wrap;
      .search-flex-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }
}

.userList-formCont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  .role-formlabel {
    width: 70px;
    text-align: right;
    margin-right: 20px;
  }
  .role-formvalue {
    width: calc(100% - 70px);
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.user-menu-cont {
  height: calc(100vh - 200px);
  overflow-y: scroll;
  background: #fff;
}
// 左侧导航滚动条消失
.user-menu-cont::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/system/userList.vue